import { Component, OnInit, ElementRef, Renderer2, EventEmitter, Input, Output } from '@angular/core';
import { Http } from "@angular/http";
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from "../Services/form.service";
import { CustomerInputService } from '../Services/customer-input.service';
import { AuthService } from '../Services/auth.service';
import { AuthControllerService } from "../Services/auth-controller.service";
import { SearchService } from '../Services/search-condition.service';
import { ListService } from '../Services/list.service';
import { SearchTopService } from '../Services/search-top.service';
import { ScService } from '../search-data/sc.service';
import * as constant from '../constant';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-search-top',
  templateUrl: './search-top.component.html',
  styleUrls: ['./search-top.component.css']
})
export class SearchTopComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  sc = Object.assign({}, this.scService.sc);
  years: string[];
  months: string[];
  days: string[];
  divisions: string[];
  users: any;
  sales_users: any;
  construction_users: any;
  a1: string[];
  a2: string[];
  a3: string[];
  a8: string[];
  Prefectures: string[];
  status: any = constant.status;
  status2: any = constant.status2;
  ranks: any = constant.ranks;
  ranks_ob: any = constant.ranks_ob;

  address: any;
  selectAuth: string = '';
  selectTemplate: string = '';
  templateTitle: string = '';
  message: string;
  error: string;

  authList: any = [];
  templateList: any = [];
  beforeTemplateTitle: string = '';

  modalReference: NgbModalRef;
  notice_ed = {
    notice_id: "",
    notice_user_code: "",
    notice: "",
    del_chk: "",
  };

  dateSelectList = [
    { id: '', text: '' },
    { id: '-1M', text: '１カ月前' },
    { id: '-2W', text: '２週間前' },
    { id: '-1W', text: '１週間前' },
    { id: '-3D', text: '３日前' },
    { id: '-1D', text: '前日' },
    { id: '0', text: '当日' },
    { id: '1D', text: '翌日' },
    { id: '3D', text: '３日後' },
    { id: '1W', text: '１週間後' },
    { id: '2W', text: '２週間後' },
    { id: '1M', text: '１カ月後' },
    { id: 'T0M', text: '当月' },
    { id: 'T1M', text: '次月' },
    { id: 'T2M', text: '次々月' },
  ];

  constructor(
    private formService: FormService,
    private _el: ElementRef,
    private renderer: Renderer2,
    private searchService: SearchService,
    private listService: ListService,
    public authService: AuthService,
    private authControllerService: AuthControllerService,
    private templateService: SearchTopService,
    private modal: NgbModal,
    private router: Router,
    private scService: ScService,
    public customerInputService: CustomerInputService,
  ) { }

  ngOnInit() {
    this.sc = Object.assign({}, this.scService.sc);
    this.a1 = this.formService.a1;
    this.a2 = this.formService.a2;
    this.a3 = this.formService.a3;
    this.a8 = this.formService.a8;
    this.Prefectures = this.formService.getPrefectures();
    this.years = this.formService.formSetYear(1900);
    this.months = this.formService.formSetMonth();
    this.setDay();
    this.message = "";
    this.error = "";
    this.serchReset();
    // 権限一覧
    this.authControllerService.getAuthList().subscribe(result => {
      this.authList = result;
    });
    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['user'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
  }


  //顧客検索
  customerSerch() {
    this.a1.forEach((val, i) => {
      if (this.sc.a1[i]) {
        this.sc.a1[i] = val;
      }
    });
    this.a3.forEach((val, i) => {
      if (this.sc.a3[i]) {
        this.sc.a3[i] = val;
      }
    });
    this.a8.forEach((val, i) => {
      if (this.sc.a8[i]) {
        this.sc.a8[i] = val;
      }
    });
    this.status.forEach((val, i) => {
      if (this.sc.status[i]) {
        this.sc.status[i] = val;
      }
    });
    this.ranks.forEach((val, i) => {
      if (this.sc.rank[i]) {
        this.sc.rank[i] = val;
      }
    });
    this.ranks_ob.forEach((val, i) => {
      if (this.sc.rank_ob[i]) {
        this.sc.rank_ob[i] = val;
      }
    });
    this.scService.sc = this.sc;
    this.router.navigate(['/result/']);
  }

  //リセット
  serchReset() {
    this.sc = Object.assign({}, this.scService.init_sc);
    this.sc.conditions = 'and';
    this.sc.sales_contact_code = 'login_user';
    this.sc.division_code = '';
    this.sc.status = {};
    this.sc.rank = {};
    this.sc.rank_ob = {};
    this.a1 = this.formService.a1;
    this.a2 = this.formService.a2;
    this.a3 = this.formService.a3;
    this.a8 = this.formService.a8;
    this.scService.sc = this.sc;
  }

  selectedAuth() {
    this.message = "";
    this.error = "";
    this.templateService.getTemplateList(this.selectAuth).subscribe(result => {
      this.templateList = result;
      this.selectTemplate = '';
      this.beforeTemplateTitle = '';
      this.serchReset();
    });
  }
  selectedTemplate(id) {
    this.message = "";
    this.error = "";
    this.selectTemplate = id;
    this.templateService.getTemplate(this.selectTemplate).subscribe(result => {
      this.templateTitle = result['title'];
      this.beforeTemplateTitle = this.templateTitle;
      this.sc = result['search_condition'];
      // 旧データの補正
      if (this.sc.status == null) {
        this.sc.status = [];
      }
      if (this.sc.rank == null) {
        this.sc.rank = [];
      }
      if (this.sc.rank_ob == null) {
        this.sc.rank_ob = [];
      }
    });
  }
  updTemplate() {
    this.message = "";
    this.error = "";
    if (this.selectTemplate == '' || this.beforeTemplateTitle != this.templateTitle) {
      this.templateService.addTemplate(this.selectAuth, this.templateTitle, this.sc).subscribe(res => {
        if (res['result'] == 0) {
          this.message = "検索条件を保存しました";
          this.error = "";
          this.beforeTemplateTitle = this.templateTitle;
        } else {
          this.message = "";
          this.error = "検索条件の保存に失敗しました";
        }
      });
    } else {
      this.templateService.updateTemplate(this.selectTemplate, this.templateTitle, this.sc).subscribe(res => {
        if (res['result'] == 0) {
          this.message = "検索条件を保存しました";
          this.error = "";
          this.beforeTemplateTitle = this.templateTitle;
        } else {
          this.message = "";
          this.error = "検索条件の保存に失敗しました";
        }
      });
    }
  }
  delTemplate(noticeDel) {
    this.modalReference = this.modal.open(noticeDel, { centered: true });
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  runDelete() {
    this.message = "";
    this.error = "";
    if (this.notice_ed.del_chk != '1') {
      //モーダル閉じる
      this.modalReference.close();
    } else {
      this.templateService.delTemplate(this.selectTemplate).subscribe(res => {
        if (res['result'] == 0) {
          this.message = "検索条件を削除しました";
          this.error = "";
        } else {
          this.message = "";
          this.error = "検索条件の削除に失敗しました";
        }
        //モーダル閉じる
        this.notice_ed.del_chk = '';
        this.modalReference.close();
      });
    }
  }
  //担当者絞込用
  userList(division_code) {
    /*
    let list = this.customerInputService.customerBase(division_code);
    list.subscribe(list => {
      this.users = list['user'];
    });
    */
  }

  /**
   * その年と月の日数を取得してくる
   */
  setDay() {
    this.days = this.formService.formSetDay(this.sc.sel_year, this.sc.sel_month)
  }

  /**
   * 郵便番号から住所を取得
   * @param zip 
   */
  searchZip(zip: string) {
    if (zip.length == 7) {
      this.formService.searchZip(zip).then(addr => {
        this.setZip(addr);
      });
    }
  }

  /**
   * 取得した住所をフォームにセット
   * @param addr 
   */
  setZip(addr) {
    if (addr !== undefined) {
      this.sc.pref = addr['0'];
      this.sc.city = addr['1'];
      this.sc.address = addr['2'];
    }
  }
}
